import { render, staticRenderFns } from "./ColaboradorQuestionario.vue?vue&type=template&id=3e4cb031&scoped=true&"
import script from "./ColaboradorQuestionario.vue?vue&type=script&lang=js&"
export * from "./ColaboradorQuestionario.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradorQuestionario.vue?vue&type=style&index=0&id=3e4cb031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4cb031",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})
